<template>
 <div
   class="collection-info-section"
   :class="{'--open': isOpen}"
 >
   <div class="collection-info-section__head" @click="changeOpen">
     <span class="h5 semibold">Цена</span>
     <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
   </div>
   <div class="collection-info-section__body">
     <div class="product-price-composition">
       <template v-if="priceComposition.length > 0">
         <template
           v-for="(item, index) in priceComposition"
           :key="`priceComposition-${index}`"
         >
           <div v-if="index > 0" class="--plus">
             <img src="~/assets/img/svg/common/plus.svg" alt=""/>
           </div>
           <div class="--product">
             <nuxt-img
               v-if="item?.characteristicGroup?.image_id"
               :src="String(item.characteristicGroup.image_id)"
               width="40px"
               height="40px"
               fit="fill"
               :alt="`product-price-${item?.characteristicGroup?.image_id ?? ''}`"
             />
           </div>
         </template>
         <div class="--equals">
           <img src="~/assets/img/svg/common/equals.svg" alt=""/>
         </div>
       </template>
       <div class="--price h5 semibold">
         {{ nuxtApp.$numberFormat(product?.price ?? 0) }} ₽
       </div>
       <template v-if="priceDescription">
         <div class="tooltip">
           <div class="--help tooltip__item">
             ?
           </div>
           <div class="tooltip__hover">
             <span v-html="priceDescription"/>
           </div>
         </div>
       </template>
     </div>
     <div class="information-product-price-composition h5">
       <span v-html="messagePriceComposition"/>
       <a @click="scrollToProducts">Перейти вниз к товарам</a>
     </div>
   </div>
 </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useNuxtApp } from 'nuxt/app';
import { getCharacteristicFromFull } from '~/utils/getCharacteristic';
import { appConfigStore as useAppConfigStore } from '#sitis/stores/modules/app-store';

const props = defineProps({
  product: {
    type: Object as any,
    default: () => {}
  },
  priceComposition: {
    type: Array as any,
    default: () => []
  }
});
const nuxtApp: any = useNuxtApp();
const { $ym } = useNuxtApp();
const appConfigStore = useAppConfigStore();

const priceDescription = computed(() => {
  return getCharacteristicFromFull(props?.product?.characteristics, 'price_description')?.values?.[0]?.value || appConfigStore.vars?.['Коллекции - Подсказка к стоимости комплекта'] || '';
})
const messagePriceComposition = computed(() => {
  const countNumber = props?.product?.productSetChildrenCount || 0;
  const countWord = nuxtApp.$caseWords(countNumber, ['товар', 'товара', 'товаров']);
  return `Цена указана за пример комплекта.<br/>Можно составить любой другой комплект.<br/>Всего в коллекции ${countNumber} ${countWord}.`
})

const isOpen = ref(true);
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};

const scrollToProducts = () => {
  const productsGrid = document.getElementById('products');
  if (!productsGrid) {
    return
  }

  const currentScroll = window.scrollY;
  const headerHeight = document.querySelector('.header')?.getBoundingClientRect().height || 100;
  const productCardPosition = productsGrid.getBoundingClientRect();
  const newScrollPosition = productCardPosition.top + currentScroll - headerHeight - 20;

  window.scrollTo({
    top: newScrollPosition,
    left: 0,
    behavior: 'smooth'
  });

  if (typeof $ym === 'function') {
    $ym('reachGoal', 'click_view_all_items')
  }
}
</script>

<style lang="scss" scoped>
.product-price-composition {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 370px;
  min-height: 36px;

  .--product {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
  }

  .--plus {
    width: 11px;
    margin: 0 18px;
    img {filter: invert(70%) sepia(0%) saturate(2514%) hue-rotate(341deg) brightness(88%) contrast(89%);}
  }

  .--equals {
    margin: 0 auto;
    img {filter: invert(70%) sepia(0%) saturate(2514%) hue-rotate(341deg) brightness(88%) contrast(89%);}
  }

  .--price {
    color: #000;
    line-height: 100%;
  }

  .--help {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #F5F5F5;
    border-radius: 6px;
    margin-left: 16px;
    cursor: pointer;
    color: #989898;
    font-size: 10px;
    line-height: 100%;
    font-weight: 600;
  }

  .tooltip__hover {
    max-width: 220px;
  }
}

.information-product-price-composition {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 14px;
  color: #989898;

  a {
    cursor: pointer;
    margin-top: 18px;
    border-bottom: 1px solid;
    line-height: 100%;

    &:hover {
      border-bottom-color: transparent;
    }
  }
}

@media (max-width: 1023px) {
  .collection-info-section__body {
    margin-top: 24px;
  }
  .collection-info-section__head {
    display: none;
  }
  .product-price-composition {
    .--plus {
      width: 9px;
      margin: 0px 14px;
    }
    .--equals {
      width: 9px;
      margin: 0px 14px;
    }
  }
  .information-product-price-composition.h5 {
    margin-top: 17px;
    font-size: 14px;
  }
}
</style>
